var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Dropdown, FormController, FormLabel, MenuItem, } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState, } from 'react';
import { useCommonContext } from '../../hooks/useContexts';
import { pushEventInfo } from '../../utils/analytics';
import { DateRanges } from '../../utils/DateRanges';
import { pushPurchaseHistorySortEvent } from '../../utils/purchase-history/analytics';
import { CustomDateRangeModal } from './CustomDateRangeModal';
// TODO: Replace Luxon's DateTime.local().toLocaleString(DateTime.DATE_HUGE) with Day.js equivalent
// const formattedDate = dayjs().format('MMMM D, YYYY');
var MenuItems = {
    recentOrders: 'Recent Orders',
    yesterday: 'Yesterday',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    last6Months: 'Last 6 Months',
    last12Months: 'Last 12 Months',
    last2Years: 'All Available Orders (25 Months)',
    YTD: 'Year To Date',
};
var getCustomText = function (startDate, endDate) {
    if (startDate !== null && endDate !== null) {
        var trimedStartDate = startDate.toLocaleString();
        var trimedEndDate = endDate.toLocaleString();
        return "".concat(trimedStartDate, " - ").concat(trimedEndDate);
    }
    return 'Custom Date Range';
};
var customDateRangeMenuItem = function (dateRangeState, dateSelectorValue) {
    var startDate = dateRangeState.startDate, endDate = dateRangeState.endDate, setStartDate = dateRangeState.setStartDate, setEndDate = dateRangeState.setEndDate, setOpen = dateRangeState.setOpen;
    var customText = getCustomText(startDate, endDate);
    if (customText || dateSelectorValue === 'custom') {
        return (React.createElement(MenuItem, { onClick: function () {
                setOpen(true);
            }, value: "custom" },
            getCustomText(startDate, endDate),
            ' '));
    }
    if (customText !== 'Custom Date Range' && dateSelectorValue === 'custom') {
        return (React.createElement(MenuItem, { value: "", onClick: function () {
                setOpen(true);
                setStartDate(null);
                setEndDate(null);
            } }, "Clear Date Range"));
    }
    return '';
};
var renderClearMenuItem = function (dateSelectorValue, dateRangeState) {
    var startDate = dateRangeState.startDate, endDate = dateRangeState.endDate, setStartDate = dateRangeState.setStartDate, setEndDate = dateRangeState.setEndDate;
    if (dateSelectorValue === 'custom' &&
        startDate !== null &&
        endDate !== null) {
        return (React.createElement(MenuItem, { value: "", onClick: function () {
                setStartDate(null);
                setEndDate(null);
            } }, "Clear Date Range"));
    }
    return undefined;
};
var disableMenuItemLogic = function (index, viewableMenuItems) {
    if (viewableMenuItems) {
        return index >= viewableMenuItems;
    }
    return false;
};
export var DateSelectionDropdown = function (_a) {
    var label = _a.label, dateSelectorValue = _a.dateSelectorValue, setDateSelectorValue = _a.setDateSelectorValue, enableFullWidth = _a.enableFullWidth, viewableMenuItems = _a.viewableMenuItems, setPHRequest = _a.setPHRequest, handleModalClose = _a.handleModalClose, page = _a.page;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(null), startDate = _c[0], setStartDate = _c[1];
    var _d = useState(null), endDate = _d[0], setEndDate = _d[1];
    var commonContext = useCommonContext();
    var dateRangeState = {
        startDate: startDate,
        endDate: endDate,
        open: open,
        setEndDate: setEndDate,
        setStartDate: setStartDate,
        dateSelectorValue: dateSelectorValue,
        setOpen: setOpen,
    };
    useEffect(function () {
        commonContext === null || commonContext === void 0 ? void 0 : commonContext.setDateRangeOptions(DateRanges[dateSelectorValue]);
    }, []);
    return (React.createElement(FormController, { fullWidth: enableFullWidth, style: { width: '214px' } },
        React.createElement(FormLabel, { htmlFor: "date-selector-dropdown" }, label),
        React.createElement(Dropdown, { id: "date-selector-dropdown", onChange: function (event, value) {
                pushPurchaseHistorySortEvent(value);
                if (page === 'business-tools') {
                    pushEventInfo({
                        category: { primaryCategory: 'button submission' },
                        eventInfo: { eventName: 'my account settings' },
                        stash: {
                            myAccount: {
                                settings: "track business spend: view history from ".concat(value),
                            },
                        },
                    });
                }
                if (value === 'custom' || DateRanges[value] === undefined) {
                    setDateSelectorValue('custom');
                    setOpen(true);
                }
                else {
                    setDateSelectorValue(value);
                    commonContext === null || commonContext === void 0 ? void 0 : commonContext.setDateRangeOptions(DateRanges[value]);
                    if (setPHRequest) {
                        var fixedStart_1 = DateRanges[event.target.value].startDate;
                        var fixedEnd_1 = DateRanges[event.target.value].endDate;
                        setPHRequest(function (prevState) {
                            return __assign(__assign({}, prevState), { startDate: fixedStart_1, endDate: fixedEnd_1, pageNumber: 1 });
                        });
                        if (handleModalClose)
                            handleModalClose();
                    }
                }
            }, value: dateSelectorValue },
            Object.keys(MenuItems).map(function (key, index) {
                return (React.createElement(MenuItem, { key: key, value: key, disabled: disableMenuItemLogic(index, viewableMenuItems) }, MenuItems[key]));
            }),
            customDateRangeMenuItem(dateRangeState, dateSelectorValue),
            !viewableMenuItems &&
                renderClearMenuItem(dateSelectorValue, dateRangeState)),
        React.createElement(CustomDateRangeModal, { open: open, handleClose: function () { return setOpen(false); }, dateRangeState: dateRangeState, setDateRangeOptions: commonContext === null || commonContext === void 0 ? void 0 : commonContext.setDateRangeOptions, setPHRequest: setPHRequest, handleModalClose: handleModalClose })));
};
